// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:host {
    font-family: var(--font-family);
    width: 100%;
}
table {
    border-collapse: collapse;
    width: 100%;
}
th, td {
    border-top: 1px solid var(--border-strong);
    border-bottom: 1px solid var(--border-strong);
    padding: var(--spacing-20);
    background: var(--background-white);
    text-align: left;
}
td {
    border-top: 1px solid var(--border-light);
    border-bottom: 1px solid var(--border-light);
}
tr {
    height: var(--spacing-50);
}

:host([kind="zebra"]) tr:nth-child(2n) td {
    background: var(--background-light);
}



/*============================================================================*/
/*child rows*/
/*============================================================================*/
td a.subtle {
    color: var(--text-default);
    font-family: var(--p2-regular-underlined-font-family);
    font-size: var(--p2-regular-underlined-font-family);
    letter-spacing: var(--p2-regular-underlined-font-family);
    line-height: var(--p2-regular-underlined-font-family);
    font-weight: var(--p2-regular-underlined-font-family);
}
.child-row table {
    width: auto;
}
.child-row td {
    background: var(--background-light);
    border: none;
}
.child-row td:not(.title) {
    padding-top: unset;
    padding-bottom: unset;
}
.child-row .title {
    font-family: var(--p2-medium-font-family);
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-letter-spacing);
    line-height: var(--p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
}


@media (max-width: 940px) {
    :host {
        overflow-x: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/table/style/index.css"],"names":[],"mappings":";AACA;IACI,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,0CAA0C;IAC1C,6CAA6C;IAC7C,0BAA0B;IAC1B,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,yCAAyC;IACzC,4CAA4C;AAChD;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;;;AAIA,+EAA+E;AAC/E,aAAa;AACb,+EAA+E;AAC/E;IACI,0BAA0B;IAC1B,qDAAqD;IACrD,mDAAmD;IACnD,wDAAwD;IACxD,qDAAqD;IACrD,qDAAqD;AACzD;AACA;IACI,WAAW;AACf;AACA;IACI,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,+CAA+C;IAC/C,yCAAyC;IACzC,yCAAyC;AAC7C;;;AAGA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["\n:host {\n    font-family: var(--font-family);\n    width: 100%;\n}\ntable {\n    border-collapse: collapse;\n    width: 100%;\n}\nth, td {\n    border-top: 1px solid var(--border-strong);\n    border-bottom: 1px solid var(--border-strong);\n    padding: var(--spacing-20);\n    background: var(--background-white);\n    text-align: left;\n}\ntd {\n    border-top: 1px solid var(--border-light);\n    border-bottom: 1px solid var(--border-light);\n}\ntr {\n    height: var(--spacing-50);\n}\n\n:host([kind=\"zebra\"]) tr:nth-child(2n) td {\n    background: var(--background-light);\n}\n\n\n\n/*============================================================================*/\n/*child rows*/\n/*============================================================================*/\ntd a.subtle {\n    color: var(--text-default);\n    font-family: var(--p2-regular-underlined-font-family);\n    font-size: var(--p2-regular-underlined-font-family);\n    letter-spacing: var(--p2-regular-underlined-font-family);\n    line-height: var(--p2-regular-underlined-font-family);\n    font-weight: var(--p2-regular-underlined-font-family);\n}\n.child-row table {\n    width: auto;\n}\n.child-row td {\n    background: var(--background-light);\n    border: none;\n}\n.child-row td:not(.title) {\n    padding-top: unset;\n    padding-bottom: unset;\n}\n.child-row .title {\n    font-family: var(--p2-medium-font-family);\n    font-size: var(--p2-medium-font-size);\n    letter-spacing: var(--p2-medium-letter-spacing);\n    line-height: var(--p2-medium-line-height);\n    font-weight: var(--p2-medium-font-weight);\n}\n\n\n@media (max-width: 940px) {\n    :host {\n        overflow-x: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
